<template>
  <div style="width: 100%;height: 100%;overflow: auto">
    <el-form v-show="!isPrint" :inline="true" :model="formInline">
      <el-form-item  :label="'页码选择（总页数：' + total + '）'">
        <el-input  type="number" v-model="pageNo" placeholder="请选择页数(每页10)"></el-input>
      </el-form-item>
      <el-form-item >
        <el-button type="primary" @click="surePage">选择</el-button>
        <el-button type="primary" v-show="endFor" @click="print">打印</el-button>
      </el-form-item>
    </el-form>

    <div id="content" style="margin: 0;padding: 0;" ref="print-content">
      <div class="pageItem">
        <div v-for="(item,index) in dataList" :key="index"
             style="width: 50%;float: left;height: 223.8px !important;overflow: hidden" >
<!--        <div v-for="(item,index) in dataList" :key="index"-->
<!--             :style="parseInt((index-1) / 9) >= 1 ? 'width: 50%;float: left;margin-top: 5.55px;' : 'width: 50%;float: left;'" >-->
          <div style="text-align: center;font-weight:  bold;font-size: 17px;line-height: 40px;height: 40px;">
            {{ dataInfo.title }}</div>
          <div style="width: 64%;padding-left: 20px;float: left;height: 80px;">
            <img :id="'barcode-' + item.couponCode" style="width: 100%;height: 70px;">
            <div style="text-align: center;margin-top: -5px;font-size: 15px;">{{ item.couponCode }}</div>
          </div>
          <div style="width: 29%;float: left;text-align: center;padding-left: 5%;height: 80px;">
            <div style="text-align: center;font-size: 35px;font-weight: bold;line-height: 60px;float: left;letter-spacing: 1px;">{{ item.amount }}</div>
            <div style="text-align: left;font-size: 23px;font-weight: 500;line-height: 80px;float: left;">元</div>
          </div>
          <div style="width: 7%;float: right;font-weight: 400;font-size: 14px;padding-right: 15px;">
            赠
          </div>
          <div style="clear: both;"></div>
          <div style="padding-left: 20px;width: 100%;">
            <div style="font-size: 12px;line-height: 15px;">
              <span style="float: left;">♦限&nbsp;&nbsp;{{ dataInfo.area }}&nbsp;&nbsp;使用;</span>
              <span style="float: right;padding-right: 15px;">♦此券不兑现，不找零，遗失不补</span>
            </div>
            <div style="clear: both;"></div>
            <div style="font-size: 12px;line-height: 15px;">
              ♦{{ dataInfo.useInfo }};
            </div>
            <div style="font-size: 12px;line-height: 15px;">
              <div style="width: 18%;float: left;text-align: left;font-size: 12px;">♦此券仅限</div>
              <div style="width: 35%;float: left;text-align: center;font-size: 12px;">{{ startDate }}-{{ endDate }}</div>
              <div style="width: 47%;float: left;text-align: right;font-size: 12px;padding-right: 15px;">使用，过期作废，盖章有效</div>
            </div>
            <div style="clear: both;margin-top: 0px;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GrouponApi from "../../../../api/sm/market/groupon/grouponApi";
import JsBarCode from "jsbarcode";
import common from "../../../../util/common";

export default {
  name: "groupPrintIframe",
  data() {
    return {
      isPrint: false,
      dataList: [],
      recordId: '',
      dataInfo: {},
      startDate: '',
      endDate: '',
      pageNo: 1,
      total: 0,
      endFor: false
    }
  },
  created() {
    let url = window.location.href
    console.log(url)
    url = url.split("?")
    url = url[1]
    url = url.split("=")
    this.recordId = url[1]
    console.log('222' + this.recordId)
  },
  mounted() {
    let that = this
    this.onInit().then(async function() {
      await that.getDetailInfo()
    }).then(function () {
      that.printItem()
    })

  },
  methods: {
    onInit() {
      return Promise.resolve()
    },
    surePage() {
      this.printItem()
    },
    print() {
      this.isPrint = true;
      this.endFor = false;
      localStorage.setItem('recordId', this.recordId)
      setTimeout(() => {
        this.$print(this.$refs['print-content'])  //打印
        this.isPrint = false;
        this.endFor = true;
      });
    },
    getDetailInfo() {
      let that = this

      GrouponApi.getDetail(this.recordId).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.dataInfo = res.data
          let list = res.data.templateList
          list = list[0]
          that.startDate = common.dateFormatTransfer(list.startDate)
          that.endDate = common.dateFormatTransfer(list.endDate)
        } else {
          alert(res.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    async printItem() {
      let pageNumber = (parseInt(this.pageNo) - 1) * 10;
      let res = await GrouponApi.getCouponInfoNoPage({recordId: this.recordId, number: pageNumber })
      res = res.data
      console.log(res)
      res = res.data
      this.dataList = res
      if (this.total == 0) {
        this.total = parseInt(this.dataList.length / 10)
      }
      let that = this
      setTimeout(() => {
        this.dataList.map(item => {
          that.createTm(item)
        })
        this.endFor = true
      }, 2000)
      console.log(this.dataList)
    },
    createTm(item) {
      JsBarCode('#barcode-' + item.couponCode, item.couponCode, {
        format: 'CODE128',
        lineColor: '#000',
        background: '#fff',
        width: 1,
        height: 70,
        displayValue: false
      })
    }
  }
}
</script>

<style scoped>
@media print {
  @page {
    size: auto;
    margin: 0.5mm 0mm;
  }
  body, html {
    height: auto !important;
    overflow: auto !important;
  }
}
</style>